import axios from "axios";

const api = axios.create({
  baseURL: "https://ngo-static-backend.herokuapp.com/api/v1/",
  // baseURL: "https://ngo-static.herokuapp.com/api/v1/",
});

export const sendPledge = (payload) => api.post("/form", payload);
export const getPledge = () => api.get("/form");
